var _defs, _g, _line, _line2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsSidesFries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "55.83 56.83 55.83 26 64.14 26 64.14 56.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "88.53 45.16 91.04 32.5 82.84 31.42 79.25 49.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.67 45.5 30.79 30.97 38.99 29.89 43.22 51.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "44.55 52.18 42.24 23.43 50.52 22.99 53.19 56.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "75.93 51.6 79.87 23.68 71.62 22.9 66.95 55.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.11,101.58c-8.71,0-17.42-1.9-26.13-1.9s-17.21,1.9-25.81,1.9c-3.55-18.69-7.09-37.39-10.64-56.08h11.75s12.92,11.77,24.85,11.77,24.73-11.77,24.73-11.77h11.88c-3.55,18.69-7.09,37.39-10.64,56.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59.98,
    cy: 77.52,
    r: 9.1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.96,
    y1: 71.73,
    x2: 79.85,
    y2: 91.64
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.54,
    y1: 59.9,
    x2: 85.8,
    y2: 62.74
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsSidesFries);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_SidesFries.115639a4b5dc9261b3b28906eae164c5.svg";
export { ForwardRef as ReactComponent };